// extracted by mini-css-extract-plugin
export default {"headerContainer":"headerTitle_headerContainer__U3uH+","cancelBtn":"headerTitle_cancelBtn__R+yCF"};